/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Kindle_Listen_Error_RetryInputs */

const en_kindle_listen_error_retry = /** @type {(inputs: Kindle_Listen_Error_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Something went wrong — tap to retry`)
};

const es_kindle_listen_error_retry = /** @type {(inputs: Kindle_Listen_Error_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Algo salió mal — toca para reintentar`)
};

/**
* | output |
* | --- |
* | "Something went wrong — tap to retry" |
*
* @param {Kindle_Listen_Error_RetryInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const kindle_listen_error_retry = /** @type {((inputs?: Kindle_Listen_Error_RetryInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Kindle_Listen_Error_RetryInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_kindle_listen_error_retry(inputs)
	return en_kindle_listen_error_retry(inputs)
});